import React, { useState } from 'react'
import styles from './styles.module.css'

function PriceHistory ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const sortedPrices = (record?.prices || []).sort((a, b) => {
    const dateA = new Date(a.lastDateSeen || 0) // Use 0 as fallback if lastDateSeen is null/undefined
    const dateB = new Date(b.lastDateSeen || 0)
    return dateB - dateA // Descending order
  })

  const visiblePrices = isExpanded ? sortedPrices : sortedPrices.slice(0, 3) // Show only 3 initially

  return (
    <section className={styles.containerPriceHistory}>
      <span className={styles.priceHistoryTitle}>Price History</span>

      {sortedPrices.length > 0 ? (
        <div className={styles.priceHistoryList}>
          {/* Header */}
          <div className={styles.headerRowPriceHistory}>
            <span className={styles.headerPriceHistory}>Min price</span>
            <span className={styles.headerPriceHistory}>Max price</span>
            <span className={styles.headerPriceHistory}>Condition</span>
            <span className={styles.headerPriceHistory}>Shipping</span>
            <span className={styles.headerPriceHistory}>Merchant</span>
            <span className={styles.headerPriceHistory}>URL</span>
            <span className={styles.headerPriceHistory}>First date seen</span>
            <span className={styles.headerPriceHistory}>Last date seen</span>
          </div>

          {/* Rows */}
          {visiblePrices.map((price, index) => (
            <div key={index} className={styles.priceHistoryRow}>
              <span className={styles.cellPriceHistory}>
                {price.amountMin ? `$${price.amountMin}` : 'N/A'}
              </span>
              <span className={styles.cellPriceHistory}>
                {price.amountMax ? `$${price.amountMax}` : 'N/A'}
              </span>
              <span className={styles.cellPriceHistory}>
                {price.condition || 'N/A'}
              </span>
              <span className={styles.cellPriceHistory}>
                {price.shipping || 'N/A'}
              </span>
              <span className={styles.cellPriceHistory}>
                {price.merchant || 'N/A'}
              </span>
              <span className={styles.cellPriceHistory}>
                {price?.sourceURLs ? price?.sourceURLs[0] : 'N/A'}
              </span>
              <span className={styles.cellPriceHistory}>
                {price.firstDateSeen
                  ? new Intl.DateTimeFormat('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    }).format(new Date(price.firstDateSeen))
                  : 'N/A'}
              </span>
              <span className={styles.cellPriceHistory}>
                {price.lastDateSeen
                  ? new Intl.DateTimeFormat('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    }).format(new Date(price.lastDateSeen))
                  : 'N/A'}
              </span>
            </div>
          ))}

          {/* Expand Button */}
          {sortedPrices.length > 3 && (
            <button
              className={styles.expandButtonPriceHistory}
              onClick={toggleExpand}
            >
              {isExpanded ? 'Show less' : `Expand all (${sortedPrices.length})`}
            </button>
          )}
        </div>
      ) : (
        ''
      )}
    </section>
  )
}

export default PriceHistory
